"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Months = exports.DaysOfWeek = void 0;
var DaysOfWeek;
(function (DaysOfWeek) {
    DaysOfWeek["MON"] = "mon";
    DaysOfWeek["TUE"] = "tue";
    DaysOfWeek["WED"] = "wed";
    DaysOfWeek["THU"] = "thu";
    DaysOfWeek["FRI"] = "fri";
    DaysOfWeek["SAT"] = "sat";
    DaysOfWeek["SUN"] = "sun";
})(DaysOfWeek = exports.DaysOfWeek || (exports.DaysOfWeek = {}));
var Months;
(function (Months) {
    Months["JAN"] = "jan";
    Months["FEB"] = "feb";
    Months["MAR"] = "mar";
    Months["APR"] = "apr";
    Months["MAY"] = "may";
    Months["JUN"] = "jun";
    Months["JUL"] = "jul";
    Months["AUG"] = "aug";
    Months["SEP"] = "sep";
    Months["OCT"] = "oct";
    Months["NOV"] = "nov";
    Months["DEC"] = "dec";
})(Months = exports.Months || (exports.Months = {}));
